import React, { Component } from "react";
import PropTypes from "prop-types";

class Icon extends Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
  };

  static defaultProps = {
    size: 24,
    color: "currentColor",
    className: "",
  };

  render() {
    let { icon, className, size, color, ...props } = this.props;

    const svg = {
      accessTime: () => [
        <title key="title">Temps</title>,
        <path
          key="path"
          d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10c5.5,0,10-4.5,10-10S17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8 S16.4,20,12,20z M12.5,7H11v6l5.2,3.1l0.8-1.2l-4.5-2.7V7z"
        />,
      ],
      addAlert: () => [
        <title key="title">Ajouter une alerte</title>,
        <path
          key="path"
          d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
        />,
      ],
      age: () => [
        <title key="title">Age</title>,
        <path
          key="path"
          d="M12,6c1.1,0,2-0.9,2-2c0-0.4-0.1-0.7-0.3-1L12,0l-1.7,3C10.1,3.3,10,3.6,10,4C10,5.1,10.9,6,12,6z M16.6,16l-1.1-1.1 L14.5,16c-1.3,1.3-3.6,1.3-4.9,0l-1.1-1.1L7.4,16c-0.7,0.6-1.5,1-2.4,1c-0.7,0-1.4-0.2-2-0.6V21c0,0.5,0.5,1,1,1h16 c0.5,0,1-0.5,1-1v-4.6c-0.6,0.4-1.2,0.6-2,0.6C18.1,17,17.2,16.6,16.6,16z M18,9h-5V7h-2v2H6c-1.7,0-3,1.3-3,3v1.5c0,1.1,0.9,2,2,2 c0.5,0,1-0.2,1.4-0.6l2.1-2.1l2.1,2.1c0.7,0.7,2,0.7,2.8,0l2.1-2.1l2.1,2.1c0.4,0.4,0.9,0.6,1.4,0.6c1.1,0,2-0.9,2-2V12 C21,10.3,19.7,9,18,9z"
        />,
      ],
      arrowLeft: () => [
        <title key="title">Fleche vers la gauche</title>,
        <path key="path" d="M15.4,16.6L10.8,12l4.6-4.6L14,6l-6,6l6,6L15.4,16.6z" />,
      ],
      arrowRight: () => [
        <title key="title">Fleche vers la droite</title>,
        <path key="path" d="M8.6,16.6l4.6-4.6L8.6,7.4L10,6l6,6l-6,6L8.6,16.6z" />,
      ],
      arrowTop: () => [
        <title key="title">Fleche vers la haut</title>,
        <path key="path" d="M7.4,15.4l4.6-4.6l4.6,4.6L18,14l-6-6l-6,6L7.4,15.4z" />,
      ],
      arrowBottom: () => [
        <title key="title">Fleche vers la bas</title>,
        <path key="path" d="M16.6,8.6L12,13.2L7.4,8.6L6,10l6,6l6-6L16.6,8.6z" />,
      ],
      check: () => [
        <title key="title">Valider</title>,
        <path key="path" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />,
      ],
      close: () => [
        <title key="title">Fermer</title>,
        <path
          key="path"
          d="M19,6.4L17.6,5L12,10.6L6.4,5L5,6.4l5.6,5.6L5,17.6L6.4,19l5.6-5.6l5.6,5.6l1.4-1.4L13.4,12L19,6.4z"
        />,
      ],
      delete: () => [
        <title key="title">Supprimer</title>,
        <path key="path" d="M6,19c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V7H6V19z M19,4h-3.5l-1-1h-5l-1,1H5v2h14V4z" />,
      ],
      edit: () => [
        <title key="title">Modifier</title>,
        <path
          key="path"
          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        />,
      ],
      event: () => [
        <title key="title">Calendrier</title>,
        <path
          key="path"
          d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
        />,
      ],
      facebook: () => [
        <title key="title">Facebook</title>,
        <path
          key="path"
          d="M9.9,22v-9.1H6.8V9.3h3.1V6.7c0-3,1.9-4.7,4.6-4.7c1.3,0,2.4,0.1,2.7,0.1v3.2l-1.9,0c-1.5,0-1.8,0.7-1.8,1.7 v2.3H17l-0.5,3.5h-3.1V22H9.9z"
        />,
      ],
      flight: () => [
        <title key="title">Avion</title>,
        <path
          key="path"
          d="M8,21h2l5-8h5.5c0.8,0,1.5-0.7,1.5-1.5S21.3,10,20.5,10H15l-5-8H8l2.5,8H5L3.5,8H2l1,3.5L2,15h1.5L5,13h5.5L8,21z"
        />,
      ],
      impersonation: () => [
        <title key="title">Impersonation</title>,
        <path
          key="path"
          d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
        />,
      ],
      giftCard: () => [
        <title key="title">Carte cadeau</title>,
        <path
          key="path"
          d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
        />,
      ],
      group: () => [
        <title key="title">Group</title>,
        <path
          key="path"
          d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
        />,
      ],
      search: () => [
        <title key="title">Chercher</title>,
        <path
          key="path"
          d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        />,
      ],
      info: () => [
        <title key="title">Info</title>,
        <path
          key="path"
          d="M11,17h2v-6h-2V17z M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8 s8,3.6,8,8S16.4,20,12,20z M11,9h2V7h-2V9z"
        />,
      ],
      infoOutline: () => [
        <title key="title">Info</title>,
        <path
          key="path"
          d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        />,
      ],
      off: () => [
        <title key="title">Eteindre</title>,
        <path
          key="path"
          d="M13,3h-2v10h2V3z M17.8,5.2l-1.4,1.4C18,7.9,19,9.8,19,12c0,3.9-3.1,7-7,7s-7-3.1-7-7c0-2.2,1-4.1,2.6-5.4L6.2,5.2 C4.2,6.8,3,9.3,3,12c0,5,4,9,9,9s9-4,9-9C21,9.3,19.8,6.8,17.8,5.2z"
        />,
      ],
      profile: () => [
        <title key="title">Profile</title>,
        <path
          key="path"
          d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
        />,
      ],
      shop: () => [
        <title key="title">Boutique</title>,
        <path
          key="path"
          d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        />,
      ],
      star: () => [
        <title key="title">Favorie</title>,
        <path key="path" d="M12,17.3l6.2,3.7l-1.6-7L22,9.2l-7.2-0.6L12,2L9.2,8.6L2,9.2L7.5,14l-1.6,7L12,17.3z" />,
      ],
      starBorder: () => [
        <title key="title">Pas favorie</title>,
        <path
          key="path"
          d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
        />,
      ],
      starHalf: () => [
        <title key="title">Favorie moitier</title>,
        <path
          key="path"
          d="M22,9.24l-7.19-.62L12,2,9.19,8.63,2,9.24,7.46,14,5.82,21,12,17.27,18.18,21l-1.63-7ZM12,15.4V6.1l1.71,4,4.38.38L14.77,13.4l1,4.28Z"
        />,
      ],
      tips: () => [
        <title key="title">Conseil</title>,
        <path
          key="path"
          d="M9,21c0,0.5,0.4,1,1,1h4c0.6,0,1-0.5,1-1v-1H9V21z M12,2C8.1,2,5,5.1,5,9c0,2.4,1.2,4.5,3,5.7V17c0,0.5,0.4,1,1,1h6 c0.6,0,1-0.5,1-1v-2.3c1.8-1.3,3-3.4,3-5.7C19,5.1,15.9,2,12,2z M14.9,13.1L14,13.7V16h-4v-2.3l-0.9-0.6C7.8,12.2,7,10.6,7,9 c0-2.8,2.2-5,5-5s5,2.2,5,5C17,10.6,16.2,12.2,14.9,13.1z"
        />,
      ],
      today: () => [
        <title key="title">Aujourd'hui</title>,
        <path
          key="path"
          d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
        />,
      ],
      location: () => [
        <title key="title">Lieu</title>,
        <path
          key="path"
          d="M12,2C8.1,2,5,5.1,5,9c0,5.2,7,13,7,13s7-7.7,7-13C19,5.1,15.9,2,12,2z M12,11.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 s2.5,1.1,2.5,2.5S13.4,11.5,12,11.5z"
        />,
      ],
      love: () => [
        <title key="title">Amour</title>,
        <path
          key="path"
          d="M12,21.3L10.6,20C5.4,15.4,2,12.3,2,8.5C2,5.4,4.4,3,7.5,3c1.7,0,3.4,0.8,4.5,2.1C13.1,3.8,14.8,3,16.5,3 C19.6,3,22,5.4,22,8.5c0,3.8-3.4,6.9-8.6,11.5L12,21.3z"
        />,
      ],
      calendarHeart: () => [
        <title key="title">Suivre</title>,
        <path
          key="path"
          d="M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zm80 205.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 393.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 240c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        />,
      ],
      default: () => [
        <title key="title">Warning</title>,
        <path key="path" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />,
      ],
    };

    if (typeof svg[icon] !== "function") {
      console.error(`The icon name: "${icon}" does not exist!`);
      icon = "default";
      color = "#ef5350";
    }

    return (
      <svg
        fill={color}
        className={`st-icon ${className}`}
        viewBox="0 0 24 24"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        {...props}
      >
        {svg[icon]()}
        <path d="M0,0h24v24H0V0z" fill="none" />
      </svg>
    );
  }
}

export default Icon;
